import KunLoading114 from './src/index'

KunLoading114.install = function (Vue) {
	Vue.component(KunLoading114.name, KunLoading114);
}

export default KunLoading114;
